module.exports = __webpack_public_path__ + "images/adoramabg912d7514deb74c7bd96725a0cecf85ca.png";